import { useState, useEffect, useRef } from 'react';
import { Fireworks } from 'fireworks-js';
import { fireworksConfig } from './fireworksConfig';

export function useFireworks() {
    const [showFireworks, setShowFireworks] = useState(false);
    const fireworksContainerRef = useRef(null);
    const fireworksInstanceRef = useRef(null);
    const audioRef = useRef(null);

    useEffect(() => {
        if (showFireworks && fireworksContainerRef.current) {
            fireworksInstanceRef.current = new Fireworks(fireworksContainerRef.current, fireworksConfig);
            fireworksInstanceRef.current.start();

            audioRef.current = new Audio('/sound/fireworks.wav');
            audioRef.current.play();
        }

        return () => {
            if (fireworksInstanceRef.current) {
                fireworksInstanceRef.current.stop();
                fireworksInstanceRef.current = null;
            }
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current = null;
            }
        };
    }, [showFireworks]);

    return { showFireworks, setShowFireworks, fireworksContainerRef };
}
